var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81399 7.07098L0.863994 2.12098C0.681836 1.93238 0.581042 1.67978 0.58332 1.41758C0.585599 1.15538 0.690768 0.904571 0.876176 0.719163C1.06158 0.533755 1.3124 0.428586 1.57459 0.426307C1.83679 0.424029 2.08939 0.524823 2.27799 0.706981L7.93499 6.36398C8.12247 6.55151 8.22778 6.80582 8.22778 7.07098C8.22778 7.33615 8.12247 7.59045 7.93499 7.77798L2.27799 13.435C2.08939 13.6171 1.83679 13.7179 1.57459 13.7157C1.3124 13.7134 1.06158 13.6082 0.876176 13.4228C0.690768 13.2374 0.585599 12.9866 0.58332 12.7244C0.581042 12.4622 0.681836 12.2096 0.863994 12.021L5.81399 7.07098Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/rightChevron.b8f36e2e72265985bfd2e3dcfc8c10ba.svg";
export { ForwardRef as ReactComponent };